import React from "react";
import "./Notification.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeOpen } from "@fortawesome/free-regular-svg-icons";
import { faEnvelopeCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { url } from "../../constants/url";
import { useAuth } from "../../Context/UserContext";
import { toast } from "react-toastify";

function Notification(props) {

  const { setOpenNotification, notificationData, fetchNotification, hoverOnEnvelope, setHoverOnEnvelope, logout } = props;

  const formatTime = (time) => {
    const now = new Date();
    const messageTime = new Date(time);
    const diffInMs = now - messageTime;

    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 1) {
      return messageTime.toLocaleDateString();
    } else if (days === 1) {
      return "1 day ago";
    } else if (hours >= 1) {
      return `${hours}h ago`;
    } else if (minutes >= 1) {
      return `${minutes}m ago`;
    } else {
      return "Now";
    }
  };

  const handleReadNotification = async (id) => {
    try {
      const response = await fetch(`${url}/markread`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      });
      if (response.status === 200) {
        fetchNotification();
        return;
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnEnvelope = () => {
    setHoverOnEnvelope(true);
  };
  const handleOutEnvelope = () => {
    setHoverOnEnvelope(false);
  };


  return (
    <div className="isecurion_notification_container">
      <div className="isecurion_notification_content">
        <div className="isecurion_notification_header_container">
          <div className="isecurion_notification__header_title">
            Notifications
          </div>
          <div
            className="isecurion_notification__header_close"
            onClick={() => setOpenNotification(false)}
          >
            X
          </div>
        </div>

        <div className="isecurion_notification_body_container">
          {notificationData.length > 0 ? (
            notificationData
              .slice()
              .sort((a, b) => new Date(b.time) - new Date(a.time))
              .map((message, index) => (
                <div className="isecurion_notification_body"
                  key={index}>

                  {!message.read && hoverOnEnvelope && (
                    <div className="isecurion_envelope_hover">
                      <p>Mark as read</p>
                    </div>
                  )}
                  <div style={{ display: "flex", marginBottom: "-10px" }}>
                    <p style={{ width: "90%" }}>{formatTime(message.time)}</p>
                    <button
                      onClick={() => handleReadNotification(message._id)}
                      onMouseOver={handleOnEnvelope}
                      onMouseOut={handleOutEnvelope}
                    >
                      <FontAwesomeIcon icon={message.read ? faEnvelopeOpen : faEnvelopeCircleCheck} />
                    </button>

                  </div>

                  <h2
                    style={{
                      fontWeight: message.read ? '400' : '600', 
                      paddingTop: '10px',
                    }}
                    dangerouslySetInnerHTML={{ __html: message.notification }}></h2>
                </div>
              ))
          ) : (
            <div className="no_notifications">
              <h2>Your notifications live here</h2>
            </div>
          )}
        </div>
      </div >
    </div >
  );
}

export default Notification;